<template>
  <div class="common-page order-management">
    <div class="top-box">
      <div class="search-form-box">
        <el-row :gutter="30">
          <el-form inline>
            <el-col :span="5">
              <el-form-item label="发起日期:">
                <custom-date-range
                  :start-date="searchForm.reassignTimeStart"
                  :end-date="searchForm.reassignTimeEnd"
                  @update:startDate="
                    (val) => (searchForm.reassignTimeStart = val)
                  "
                  @update:endDate="(val) => (searchForm.reassignTimeEnd = val)"></custom-date-range>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="审批状态:" prop="auditStatus">
                <el-select
                  style="width: 100%"
                  v-model="searchForm.auditStatus"
                  filterable
                  default-first-option
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="item in $dict.auditStatusOptions"
                    :key="item.dictCode"
                    :label="item.dictLabel"
                    :value="item.dictCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="">
                <el-button type="primary" round icon="el-icon-search" @click="handleCheck()"></el-button>
                <el-button type="default" round icon="el-icon-refresh" @click="handleReset()"></el-button>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </div>

    <div class="custom-table-box">
      <custom-table
        :data="tableData"
        :column="tableColumn"
        :total="tableOptions.total"
        :loading="tableOptions.loading"
        :page="tableOptions.pageNumber"
        :size="tableOptions.pageSize"
        :selection="false"
        @pagination="handleSizeChange">
        <template v-slot:orderNo="{ row }">
          <span class="color1269FF cursor" @click="openOrderDetail(row)">
            {{
            row.orderNo
            }}
          </span>
        </template>
        <template v-slot:oldDriverName="{ row }">
          <span>{{ row.oldDriverCarNumber }}|{{ row.oldDriverName }}</span>
        </template>
        <template v-slot:newDriverName="{ row }">
          <span>{{ row.newDriverCarNumber }}|{{ row.newDriverName }}</span>
        </template>
        <template v-slot:auditStatus="{ row }">
          <span class="common-status status-error" v-if="row.auditStatus === -1">已驳回</span>
          <span class="common-status status-cancel" v-if="row.auditStatus === 2">已撤销</span>
          <span class="common-status status-confirm" v-if="row.auditStatus === 1">已通过</span>
          <span class="common-status status-pending-order" v-if="row.auditStatus === 0">待审批</span>
        </template>
        <template v-slot:operation="{ row }">
          <span
            class="operate-btn"
            :class="row.auditStatus === 0 ? '' : 'disable-txt'"
            @click="row.auditStatus === 0 ? handleApproval(row) : ''">
            审批
          </span>
          <span class="operate-btn" @click="openDetail(row)">详情</span>
        </template>
      </custom-table>
    </div>

    <!--    添加或编辑-->
    <addOrEdit ref="addOrEdit"></addOrEdit>
    <detail ref="detail"></detail>
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import addOrEdit from "./addOrEdit.vue";
import { downloadTable, getPage } from "./api";
import tableMixin from "@/mixin/tableMixin";
import detail from "@/views/OrderManagement/detail.vue";
export default {
  name: "ShipperManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
    addOrEdit,
    detail,
  },
  data() {
    return {
      getTableMethod: getPage,
      downloadFileMethod: downloadTable,
      searchForm: {
        auditStatus: "",
        orderNo: "",
        reassignTimeStart: "",
        reassignTimeEnd: "",
      },
      deptList: [],
      isImmediatelyGetData: true,
      tableColumn: [
        {
          label: "发起时间",
          prop: "reassignTime",
          align: "left",
          show: true,
        },
        {
          label: "发起人",
          prop: "dispatcherName",
          align: "left",
          show: true,
        },
        {
          label: "联系方式",
          prop: "dispatcherPhone",
          align: "left",
          show: true,
        },
        {
          label: "改派订单",
          prop: "orderNo",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "原承运信息",
          prop: "oldDriverName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "改派后承运信息",
          prop: "newDriverName",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "审批状态",
          prop: "auditStatus",
          scopeStatus: true,
          align: "left",
          show: true,
        },
        {
          label: "操作",
          prop: "operation",
          fixed: "right",
          width: "160px",
          scopeStatus: true,
          show: true,
        },
      ],
      statisticsImage1: require("@/assets/imgs/huozhuzongliang.png"),
      statisticsImage2: require("@/assets/imgs/youxiaohuozhu.png"),
      statisticsImage3: require("@/assets/imgs/xiadanbishu.png"),
      statisticsImage4: require("@/assets/imgs/dingdanwancheng.png"),
      statisticsImage5: require("@/assets/imgs/leijijine.png"),
    };
  },
  created() {},
  mounted() {},
  methods: {
    openOrderDetail(row) {
      this.$refs.detail.init(row);
    },
    handleApproval(row) {
      this.$refs.addOrEdit.init("审批", false, row);
    },
    openDetail(row) {
      this.$refs.addOrEdit.init("审批详情", true, row);
    },
  },
};
</script>
<style lang="scss" scoped>
.order-management {
  .search-form-title {
    font-weight: 400;
    font-size: 0.16rem;
    color: #111827;
    line-height: 0.24rem;
    padding-bottom: 0.08rem;
  }

  .drop-image {
    width: 0.24rem;
    height: 0.24rem;
  }

  .owner-requirement {
    background-color: rgba(217, 236, 255, 0.5);
    color: #1269ff;
    padding: 0.05rem;
    border-radius: 0.06rem;
  }

  .mileage {
    position: relative;
    padding: 0 0.05rem 0.06rem;
  }

  .mileage::after {
    content: "→";
    position: absolute;
    left: 0;
    bottom: -0.06rem;
    text-align: center;
    width: 100%;
  }
  .custom-table-box {
    padding-top: 0;
  }
}
</style>
